// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.motes-profile {
  position: relative;
}
.motes-profile .profile-overview, .motes-profile .profile-options-desktop, .motes-profile .profile-options-mobile, .motes-profile .edit-mode, .motes-profile .profile-details {
  pointer-events: none;
  opacity: 0;
}
.motes-profile .profile-overview.show, .motes-profile .profile-options-desktop.show, .motes-profile .profile-options-mobile.show, .motes-profile .edit-mode.show, .motes-profile .profile-details.show {
  pointer-events: initial;
  opacity: 1;
  transition: 0.4s opacity;
}
.motes-profile .profile-overview.show .option, .motes-profile .profile-options-desktop.show .option, .motes-profile .profile-options-mobile.show .option, .motes-profile .edit-mode.show .option, .motes-profile .profile-details.show .option {
  cursor: pointer;
}
.motes-profile .log-out-overlay p {
  text-align: center;
  margin-top: 1em;
}
.motes-profile .profile-card {
  padding: 30px 30px 0 30px;
  box-sizing: border-box;
  border-radius: var(--border-radius);
  max-height: 200px;
  transition: 0.4s max-height;
  overflow: hidden;
}
.motes-profile .profile-card.expand-2 {
  max-height: 1100px;
  transition: 0.4s max-height;
}
.motes-profile .profile-card.expand-2 .profile-overview {
  padding-bottom: 0;
}
.motes-profile .profile-card .profile-overview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-height: 0;
  padding-bottom: 30px;
}
.motes-profile .profile-card .profile-overview.show {
  max-height: 100%;
}
.motes-profile .profile-card .profile-overview .profile-content {
  display: flex;
  align-items: center;
  flex-grow: 1;
  max-width: 80%;
}
.motes-profile .profile-card .profile-overview .profile-content-text {
  padding: 0 max(5%, 20px);
  margin: 0;
  font-size: 24px;
  font-family: var(--header-font);
  line-height: 29px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.motes-profile .profile-card .profile-overview .profile-content-img {
  width: 130px;
  height: 130px;
}
.motes-profile .profile-card .profile-overview .profile-content-img img {
  height: inherit;
  width: inherit;
}
.motes-profile .profile-card .profile-overview .profile-options-button {
  width: 45px;
  height: 30px;
  margin: 0;
  min-width: initial;
}
.motes-profile .profile-card .profile-overview .profile-options-desktop {
  position: absolute;
  right: 30px;
  bottom: -5px;
  background-color: var(--motes-white);
  border-radius: var(--border-radius);
  box-shadow: 0px 3px 6px rgba(50, 50, 50, 0.2);
  padding: var(--motes-padding);
  text-align: left;
}
.motes-profile .profile-card .profile-overview .profile-options-desktop button {
  display: none;
}
.motes-profile .profile-card .profile-overview .profile-options-desktop svg-icon {
  padding-right: 5px;
  font-size: 25px;
}
.motes-profile .profile-card .profile-overview .profile-options-desktop .option {
  color: var(--tertiary-color);
}
.motes-profile .profile-card .profile-overview .profile-options-desktop .option:hover {
  color: var(--secondary-color);
}
.motes-profile .profile-card .profile-options-mobile {
  max-height: 0;
}
.motes-profile .profile-card .edit-mode {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
}
.motes-profile .profile-card .edit-mode.show {
  transition: 0.4s opacity;
}
.motes-profile .profile-card .profile-details {
  max-width: var(--max-page-width);
  align-self: center;
  width: 100%;
}
.motes-profile .profile-card .profile-details h3 {
  text-align: center;
}
.motes-profile .profile-card .profile-details .toggle-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--motes-padding);
  text-align: left;
}
.motes-profile .profile-card .profile-details .toggle-container p {
  margin-bottom: 0;
  margin-right: var(--motes-padding);
}
.motes-profile .profile-card .profile-details .exit-buttons-container {
  display: flex;
  justify-content: space-between;
}
.motes-profile .profile-card .profile-details .exit-buttons-container button {
  width: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: var(--motes-padding);
  white-space: nowrap;
}
.motes-profile .profile-card .profile-details .profile-img-card {
  position: relative;
  display: flex;
  justify-content: center;
  background-color: white;
  padding: 20px;
  overflow: visible;
  box-shadow: none;
}
.motes-profile .profile-card .profile-details .profile-img-card .button-outline {
  color: initial;
}
.motes-profile .profile-card .profile-details .profile-img-card .button-circled.hide {
  transition: none;
}
.motes-profile .profile-card .profile-details .profile-img-card .profile-upload {
  width: 100%;
}
.motes-profile .profile-card .profile-details .profile-img-card .profile-upload .upload-media {
  display: flex;
  flex-direction: column-reverse;
}
.motes-profile .profile-card .profile-details .profile-img-card .profile-upload .upload-media .drop-zone {
  border: none;
  background-color: white;
}
.motes-profile .profile-card .profile-details .profile-img-card .profile-upload .upload-media .action-panel:not(.shown) {
  display: flex;
}
.motes-profile .profile-card .profile-details .profile-img-card .profile-upload .upload-media .media-preview {
  width: 200px;
  height: 100%;
  margin: 0 auto;
  padding-bottom: 10px;
}
.motes-profile .profile-card .profile-details .profile-img-card .profile-upload .upload-media .media-preview img {
  width: 100%;
  aspect-ratio: 1/1;
}
.motes-profile .profile-card .profile-details .profile-img-card .profile-upload .upload-media .image-cropper {
  max-height: 1100px;
}
.motes-profile .profile-card .profile-details .profile-img-card .profile-upload .upload-media .image-cropper img {
  border: none;
  border-radius: 0;
}
.motes-profile .profile-card .profile-details .profile-img-card .button-circled.on-profile-img {
  position: absolute;
  bottom: 44px;
  left: min(50% + 56px, 100% - 44px - 20px);
}
.motes-profile .profile-card .delete-button {
  margin-top: var(--motes-padding);
  padding: 0;
}
.motes-profile .profile-card .profile-content-img img, .motes-profile .profile-card .profile-upload img {
  height: 100%;
  border-radius: 100%;
  border: 5px solid white;
  box-shadow: 0px 5px 8px rgba(0, 0, 0, 0.1607843137);
  object-fit: cover;
}
.motes-profile .delete-overlay {
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(34, 34, 34, 0.7882352941);
  border-radius: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}
@media only screen and (max-width: 600px) {
  .motes-profile .profile-card {
    max-height: 180px;
    padding: 30px 10px 0 10px;
  }
  .motes-profile .profile-card.expand-1 {
    max-height: 306px;
  }
  .motes-profile .profile-card.expand-2 {
    max-height: 1100px;
  }
  .motes-profile .profile-card .profile-overview .profile-options-desktop {
    display: none;
  }
  .motes-profile .profile-card .profile-overview .profile-content-img img {
    width: 110px;
    height: 110px;
  }
  .motes-profile .profile-card .profile-overview .profile-content-text {
    font-size: 20px;
    line-height: 24px;
  }
  .motes-profile .profile-card .profile-options-mobile.show {
    max-height: 100%;
  }
  .motes-profile .profile-card .profile-upload .upload-media .action-panel {
    position: initial;
  }
  .motes-profile .profile-card .profile-content-img img, .motes-profile .profile-card .profile-upload img {
    border: 2px solid white;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/motes-profile/motes-profile.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,oBAAA;EACA,UAAA;AACR;AACQ;EACI,uBAAA;EACA,UAAA;EACA,wBAAA;AACZ;AACY;EACI,eAAA;AAChB;AAII;EACI,kBAAA;EACA,eAAA;AAFR;AAKI;EACI,yBAAA;EACA,sBAAA;EACA,mCAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;AAHR;AAKQ;EAEI,kBAAA;EACA,2BAAA;AAJZ;AAMY;EACI,iBAAA;AAJhB;AAQQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,oBAAA;AANZ;AAQY;EACI,gBAAA;AANhB;AASY;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAPhB;AAUY;EACI,wBAAA;EACA,SAAA;EACA,eAAA;EACA,+BAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AARhB;AAWY;EACI,YAAA;EACA,aAAA;AAThB;AAYgB;EACI,eAAA;EACA,cAAA;AAVpB;AAcY;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AAZhB;AAeY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,mCAAA;EACA,6CAAA;EACA,6BAAA;EACA,gBAAA;AAbhB;AAegB;EACI,aAAA;AAbpB;AAgBgB;EACI,kBAAA;EACA,eAAA;AAdpB;AAiBgB;EACI,4BAAA;AAfpB;AAiBoB;EACI,6BAAA;AAfxB;AAqBQ;EACI,aAAA;AAnBZ;AAsBQ;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;AApBZ;AAsBY;EACI,wBAAA;AApBhB;AAwBQ;EACI,gCAAA;EACA,kBAAA;EACA,WAAA;AAtBZ;AAwBY;EACI,kBAAA;AAtBhB;AAyBY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mCAAA;EACA,gBAAA;AAvBhB;AAyBgB;EACI,gBAAA;EACA,kCAAA;AAvBpB;AA2BY;EACI,aAAA;EACA,8BAAA;AAzBhB;AA2BgB;EACI,sBAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;AAzBpB;AA6BY;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AA3BhB;AA6BgB;EACI,cAAA;AA3BpB;AA8BgB;EACI,gBAAA;AA5BpB;AA+BgB;EACI,WAAA;AA7BpB;AA+BoB;EACI,aAAA;EACA,8BAAA;AA7BxB;AA+BwB;EACI,YAAA;EACA,uBAAA;AA7B5B;AAgCwB;EACI,aAAA;AA9B5B;AAiCwB;EACI,YAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AA/B5B;AAiC4B;EACI,WAAA;EACA,iBAAA;AA/BhC;AAsCwB;EAEI,kBAAA;AArC5B;AAwC4B;EAEI,YAAA;EACA,gBAAA;AAvChC;AA6CgB;EACI,kBAAA;EACA,YAAA;EACA,yCAAA;AA3CpB;AAgDQ;EACI,gCAAA;EACA,UAAA;AA9CZ;AAkDY;EACI,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mDAAA;EACA,iBAAA;AAhDhB;AAqDI;EACI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gDAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAnDR;AAuDI;EAEI;IACI,iBAAA;IACA,yBAAA;EAtDV;EAwDU;IACI,iBAAA;EAtDd;EAyDU;IAEI,kBAAA;EAxDd;EA6Dc;IACI,aAAA;EA3DlB;EA8Dc;IACI,YAAA;IACA,aAAA;EA5DlB;EA+Dc;IACI,eAAA;IACA,iBAAA;EA7DlB;EAiEU;IACI,gBAAA;EA/Dd;EAkEU;IACI,iBAAA;EAhEd;EAoEc;IACI,uBAAA;EAlElB;AACF","sourcesContent":[".motes-profile {\n    position: relative;\n\n    .profile-overview, .profile-options-desktop, .profile-options-mobile, .edit-mode, .profile-details {\n        pointer-events: none;\n        opacity: 0;\n\n        &.show {\n            pointer-events: initial;\n            opacity: 1;\n            transition: 0.4s opacity;\n\n            .option {\n                cursor: pointer;\n            }\n        }\n    }\n\n    .log-out-overlay p {\n        text-align: center;\n        margin-top: 1em;\n    }\n\n    .profile-card {\n        padding: 30px 30px 0 30px;\n        box-sizing: border-box;\n        border-radius: var(--border-radius);\n        max-height: 200px;\n        transition: 0.4s max-height;\n        overflow: hidden;\n\n        &.expand-2 {\n            // OBS: This needs to be big enough for any image uploaded in profile when cropping\n            max-height: 1100px;\n            transition: 0.4s max-height;\n\n            .profile-overview {\n                padding-bottom: 0;\n            }\n        }\n\n        .profile-overview {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            max-height: 0;\n            padding-bottom: 30px;\n\n            &.show {\n                max-height: 100%;\n            }\n\n            .profile-content {\n                display: flex;\n                align-items: center;\n                flex-grow: 1;\n                max-width: 80%;\n            }\n\n            .profile-content-text {\n                padding: 0 max(5%, 20px);\n                margin: 0;\n                font-size: 24px;\n                font-family: var(--header-font);\n                line-height: 29px;\n                width: 100%;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                text-align: left;\n            }\n\n            .profile-content-img {\n                width: 130px;\n                height: 130px;\n                // margin-right: 20px;\n\n                img {\n                    height: inherit;\n                    width: inherit;\n                }\n            }\n\n            .profile-options-button {\n                width: 45px;\n                height: 30px;\n                margin: 0;\n                min-width: initial;\n            }\n    \n            .profile-options-desktop {\n                position: absolute;\n                right: 30px;\n                bottom: -5px;\n                background-color: var(--motes-white);\n                border-radius: var(--border-radius);\n                box-shadow: 0px 3px 6px rgba(50,50,50,.2);\n                padding: var(--motes-padding);\n                text-align: left;\n\n                button {\n                    display: none;\n                }\n\n                svg-icon {\n                    padding-right: 5px;\n                    font-size: 25px;\n                }\n\n                .option {\n                    color: var(--tertiary-color);\n\n                    &:hover {\n                        color: var(--secondary-color);\n                    }\n                }\n            }\n        }\n\n        .profile-options-mobile {\n            max-height: 0;\n        }\n\n        .edit-mode {\n            display: flex;\n            flex-direction: column;\n            padding-bottom: 20px;\n            \n            &.show {\n                transition: 0.4s opacity;\n            }\n        }\n\n        .profile-details {\n            max-width: var(--max-page-width);\n            align-self: center;\n            width: 100%;\n\n            h3 {\n                text-align: center;\n            }\n\n            .toggle-container {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                margin-bottom: var(--motes-padding);\n                text-align: left;\n\n                p {\n                    margin-bottom: 0;\n                    margin-right: var(--motes-padding);\n                }\n            }\n\n            .exit-buttons-container {\n                display: flex;\n                justify-content: space-between;\n\n                button {\n                    width: calc(50% - 5px);\n                    margin-top: 0;\n                    margin-bottom: var(--motes-padding);\n                    white-space: nowrap;\n                }\n            }\n\n            .profile-img-card {\n                position: relative;\n                display: flex;\n                justify-content: center;\n                background-color: white;\n                padding: 20px;\n                overflow: visible;\n                box-shadow: none;\n\n                .button-outline {\n                    color: initial;\n                }\n\n                .button-circled.hide {\n                    transition: none;\n                }\n\n                .profile-upload {\n                    width: 100%;\n\n                    .upload-media {\n                        display: flex;\n                        flex-direction: column-reverse;\n\n                        .drop-zone {\n                            border: none;\n                            background-color: white;\n                        }\n\n                        .action-panel:not(.shown) {\n                            display: flex;\n                        }\n\n                        .media-preview {\n                            width: 200px;\n                            height: 100%;\n                            margin: 0 auto;\n                            padding-bottom: 10px;\n\n                            img {\n                                width: 100%;\n                                aspect-ratio: 1/1;\n                            }\n                        }\n                        \n                        .drop-zone {\n                        }\n                        \n                        .image-cropper {\n                            // OBS: This needs to be big enough for any image uploaded in profile when cropping\n                            max-height: 1100px;\n                            // margin: 0 auto;\n                            \n                            img {\n                                // width: fit-content;\n                                border: none;\n                                border-radius: 0;\n                            }\n                        }\n                    }\n                }\n\n                .button-circled.on-profile-img {\n                    position: absolute;\n                    bottom: 44px;\n                    left: min(calc(50% + 56px), calc(100% - 44px - 20px));\n                }\n            }\n        }\n\n        .delete-button {\n            margin-top: var(--motes-padding);\n            padding: 0;\n        }\n\n        .profile-content-img, .profile-upload { \n            img {\n                height: 100%;\n                border-radius: 100%;\n                border: 5px solid white;\n                box-shadow: 0px 5px 8px #00000029;\n                object-fit: cover;\n            }\n        }\n    }\n\n    .delete-overlay {\n        position: absolute;\n        z-index: 2;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background-color: #222222c9;\n        border-radius: inherit;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        pointer-events: auto;\n    }\n\n    // Mobile view\n    @media only screen and (max-width: 600px) {\n\n        .profile-card {\n            max-height: 180px;\n            padding: 30px 10px 0 10px;\n\n            &.expand-1 {\n                max-height: 306px;\n            }\n\n            &.expand-2 {\n                // OBS: This needs to be big enough for any image uploaded in profile when cropping\n                max-height: 1100px;\n            }\n\n            .profile-overview {\n    \n                .profile-options-desktop {\n                    display: none;\n                }\n                \n                .profile-content-img img {\n                    width: 110px;\n                    height: 110px;\n                }\n\n                .profile-content-text {\n                    font-size: 20px;\n                    line-height: 24px;\n                }\n            }\n            \n            .profile-options-mobile.show {\n                max-height: 100%;\n            }\n            \n            .profile-upload .upload-media .action-panel {\n                position: initial;\n            }\n\n            .profile-content-img, .profile-upload {\n                img {\n                    border: 2px solid white;\n                }\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
